<div class="product-header">
    <app-add-button
        [text]="'MANAGE_SERVICES.PRODUCT_LIST.ADD_CATEGORY'"
        [(clicked)]="showNew"
        (activated)="scrollToEnd()"
    >
    </app-add-button>
</div>

<div class="product-list-container" #productsContainer>
    <div class="product-list" style="cursor: default">
        <!-- TODO: add drag and drop -->
        <div *ngFor="let product of products; let i = index" style="cursor: default">
            <app-product-card
                [product]="product"
                [products]="products"
                [isIt]="isIt"
                style="cursor: default"
            >
            </app-product-card>
        </div>

        <ng-container *ngIf="showNew">
            <app-product-card
                [new]="true"
                [isIt]="isIt"
                [products]="products"
                (addingNewCanceled)="onAddingNewCanceled()"
            >
            </app-product-card>
        </ng-container>
    </div>
</div>
